import { SignoutSmallDTO } from "../dto/SignoutDTO";
import { Signout } from "../models/Person/Signout";

export const signoutMapper = (dto: SignoutSmallDTO): Signout => {
  return new Signout({
    id: dto.signoutId,
    program: dto.programId,
    type: dto.signoutType,
    boat: dto.boatName,
    sail: dto.sailNumber,
    role: null,
    signOutDate: dto.signoutDatetime,
    signInDate: dto.signinDatetime,
    crew: dto.crew,
    skipper: dto.skipper,
    assignedTo: dto.personId,
    testRating: null,
    testResults: null,
  });
};
